import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";

declare var ko: any;

export class jobProfileConfig_template extends vnTemplate {

    protected toolTipButton : infoButton_template;

    protected getTemplateHtml(): string {

        return `
                
                <div data-bind="css: { 'is-visible': isPopUpVisible }" class="w-lightbox light-theme lightbox-embed" id="popup-list-results">
                    <div class="lightbox-content">
                        <div class="w-form lightbox-form">

                            <div class="form-header">
                                <h3 class="form-title icon i-settings">Config Form</h3>
                                <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickClose }" ></button>
                            </div>
                            
                            <div id="spec_section" class="form-body-scroll">
                                
                                <div class="" data-bind="visible: sortables().length == 0">
                                    <span style="margin:2rem auto; display: block;background: #fffae6;padding: 1rem;max-width: 400px;border: 1px dashed #e4d8ab;"> There are no profiles available</span>
                                </div>
                                
                                <table id="spec_section_list" class="list-action full-width" data-bind="visible: sortables().length >= 1">
                                    <thead>
                                        <tr style="background-color:transparent">
                                            <th class="short"></th>  
                                            <th><span>Background Image</span></th>
                                            <th><span>Position Title</span></th>
                                            <th><span>Status ` + this.toolTipButton.getHtmlBuild() + `</span></th>
                                        </tr>
                                    </thead>
                                    <tbody data-bind="foreach: sortables, childrenComplete : handleDragAndDrop($element, sortables ,'.form-row')" >
                                        <tr class="form-row" data-bind="css:{ 'is-active' : isActive()}">       
                                            <td class="drag-handle i-move short"><button type="button" class="btn no-bg icon i-drag"></button></td>                                           
                                            <td>
                                                <div class="w-user-img">
                                                    <img data-bind="attr: { src: imageUrl }"  alt=""  src=""/>
                                                    <input type="file" accept="image/*" data-bind=" attr:{ id: 'image_' + id, name: 'image_' + id}, event: { change: $parent.onClickUpload }">
                                                </div>
                                            </td>
                                            <td><span data-bind="text: name"></td>
                                            <td>
                                                <input type="checkbox" value="1" data-bind="checked: $data.isActive, attr:{id: 'isActive_' + $index()}"/>
                                                <label data-bind="attr:{for: 'isActive_' + $index()}" class="form-label icon i-check"></label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
          
                            <div class="form-footer">
                           
                                <button type="button" data-bind="event: { click: onClickClose }" class="btn ">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn highlight">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
    }

    protected initPartial() {

        this.toolTipButton = new infoButton_template('toolTip', this.getTemplateViewModel(), this.caller)
        this.toolTipButton.setTitle('Status');
        let toolTipText = `<p><strong>Enabled</strong>: The position will be open to applicants through a listing on the website. It will appear on the website using the configured order and background image.</p>
                           <p><strong>Disabled</strong>: The listing will be removed from the website but previously submitted applications will not be affected.</p>`
        this.toolTipButton.setContent(toolTipText);
    }

    protected getTemplateName(): string {
        return "jobProfileConfig-template";
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        let viewModel = {

            isPopUpVisible: ko.observable(false)
            ,sortables:ko.observableArray([])
            ,selectedSortable: ko.observable("")
            ,onClickClose: function (data, event) {huit_neuf_this.onClickClose();}
            ,onClickSave:function (data, event) {huit_neuf_this.onClickSave();}
            ,onClickUpload:function (data, event) {huit_neuf_this.uploadImage(data, event);}
            ,handleDragAndDrop: function(element, currentObservableArray ,childrenSelector){ huit_neuf_this.handleDragAndDrop(element, currentObservableArray ,childrenSelector);}
        };
        return viewModel;
    }

    public togglePopUp(value){

        document.body.classList.toggle("is-fixed");
        this.getTemplateViewModel().isPopUpVisible(value)
    }

    public setSortables(sortables){

        this.getTemplateViewModel().sortables(sortables)
    }

    public onClickClose(){

        this.reset();
        this.togglePopUp(false);
    }

    protected onClickSave(){

        this.updatePositions();
    }

    public handleDragAndDrop(element, currentObservableArray ,childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray ,childrenSelector);
    }

    public uploadImage(data, event){

        this.getTemplateViewModel().selectedSortable(data);
        let image = event.target.files;
        if(image.length == 1){

            let formReq_url: string = '/api/job/profiles/image/upload/';

            var formData = new FormData();
            formData.append("image", image[0]);
            formData.append("idBrand", data.brand.id);

            let request = [];
            var xhttp = new XMLHttpRequest();
            request["request"] = xhttp;

            // Set POST method and ajax file path
            xhttp.open("POST", formReq_url, true);

            let onReadyStateFunction = (function (req, obj) {

                return function () {

                    if (req.request.readyState == 4) {

                        if (req.request.status == 200) {

                            let response = JSON.parse(req.request.response);
                            obj.updateSortableImageUrl(response.images[0]);

                        }
                    }
                }
            });
            // call on request changes state
            xhttp.onreadystatechange = onReadyStateFunction(request, this);
            xhttp.send(formData);
        }
    }

    public updateSortableImageUrl(imageUrl){

        let sortables = this.getTemplateViewModel().sortables()
        let selectedSortable = this.getTemplateViewModel().selectedSortable();
        selectedSortable.imageUrl = imageUrl.url;

        let index = sortables.map(function (e){return e.id}).indexOf(selectedSortable.id)

        if(index !== -1){

            sortables[index] = selectedSortable;

            this.setSortables([]);
            this.setSortables(sortables);
        }
    }

    public updatePositions(){

        let sortables = this.getTemplateViewModel().sortables();

        for (var i = 0; i < sortables.length; i++) {

            sortables[i].position = i + 1;
        }

        this.caller.bulkSave(sortables);
    }

    public reset(){

        this.getTemplateViewModel().sortables([])
        this.getTemplateViewModel().selectedSortable("");
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/jobProfileConfig_template.ts